/** @typedef {'home' | 'marketplace' | 'runner'} LandingViewMode */

/** @param {string} pathname @returns {LandingViewMode} */
export const resolveLandingViewMode = pathname => {
  if (pathname === '/marketplace') {
    return 'marketplace';
  }
  if (pathname === '/runner') {
    return 'runner';
  }
  return 'home';
};
